import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <AppSection />
        <TopicsSection />
        <FeaturesSection />
        <CardsSection />
        <FAQSection />
        <ContactSection />
        <AboutSection />
        <IndexSection />
        <RankingSection />
        <CarouselSection />
        <MediaSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}